import { NavItemAccessor } from '@billy/design-system'
import { TFunction } from 'i18next'

import { VatRateItem } from '../types/vatRateItem'
import { getRegionGroupAccessors } from './getRegionGroupAccessors'

// goes through all the vat rate items (as in VatSelect dropdown items) and groups them by existing accessors
// if there's only one accessors, there's only one group, so no point in keeping that accessor
export const getGroupedVatRateItems = (vatRateItems: VatRateItem[], t: TFunction): VatRateItem[] => {
  const groupedByAccessors = getRegionGroupAccessors(t)
    .map((accessor) => {
      const groupedItems = vatRateItems.filter(({ accessorGroupId }) => accessorGroupId === accessor.id)

      return groupedItems?.length ? [accessor, ...groupedItems] : []
    })
    .filter((group) => group.length > 0)

  const isOnlyOneGroup = groupedByAccessors.length === 1
  const groupedItemsList = groupedByAccessors.flat()

  // remove header if there's only one group left
  return isOnlyOneGroup
    ? groupedItemsList.filter((item) => item?.accessor !== NavItemAccessor.Header)
    : groupedItemsList
}
